import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";
import { runBackgroundRequest } from "../utils/backgroundRequestQueue";

const EMPTY_CLUB_ATTENTION = {
  member_activity: {
    total_unread: 0,
    unread_clubs_count: 0,
    clubs: [],
    joined_total_unread: 0,
    joined_unread_clubs_count: 0,
    joined_clubs: [],
  },
  join_requests: { total_pending: 0, pending_clubs_count: 0, clubs: [] },
};

const ClubAttentionContext = createContext(null);

export const ClubAttentionProvider = ({
  children,
  enabled = true,
  intervalMs = 60_000,
}) => {
  const { data, refetch } = useQuery({
    queryKey: ["club_attention_summary"],
    enabled: Boolean(enabled),
    queryFn: async () => {
      const response = await runBackgroundRequest(() => (
        api.get("/clubs/attention-summary/", {
          meta: { suppressGlobalError: true },
        })
      ));
      return response?.data || EMPTY_CLUB_ATTENTION;
    },
    refetchInterval: intervalMs,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  const value = useMemo(
    () => ({ data: data || EMPTY_CLUB_ATTENTION, refetch }),
    [data, refetch]
  );

  return (
    <ClubAttentionContext.Provider value={value}>
      {children}
    </ClubAttentionContext.Provider>
  );
};

export const useClubAttention = () => (
  useContext(ClubAttentionContext) || {
    data: EMPTY_CLUB_ATTENTION,
    refetch: async () => {},
  }
);
